<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block color="primary" dark v-bind="attrs" v-on="on">
        Settings
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Settings</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-checkbox
              v-model="settings.assignment"
              :label="'Assignment functionality'"
            ></v-checkbox>

            <v-text-field
            validate-on-blur
            counter="13"
            v-model="settings.default_phone"
            v-mask="'(###)###-####'"
            label="Default Phone"
            required
          />
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="updateSettings"> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SettingsForm",
  data() {
    return {
      open: false,
      checkbox: true,
    };
  },
  methods: {
    ...mapActions({
      loadSetting: "settings/loadSetting",
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),

    updateSettings() {
      this.$axios
        .post("/settings/update", {
          assignment: this.settings.assignment,
          default_phone: this.settings.default_phone,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((err) => {
          console.log("updateSettings -> err", err)
          this.showHandlerSnackbar({
            color: 'red',
            text: "Server Error",
            show: true,
          });
        });
    },
  },
  mounted() {
    this.loadSetting();
  },
  computed: {
    ...mapGetters({
      settings: "settings/settings",
    }),
  },
};
</script>

<style>
</style>